import { paths } from 'src/routes/paths';

import packageJson from '../package.json';
import { DEFAULT_LOCATION } from './constants/global-constant';

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  areaJsonUrl: string;
  baseUrl: string;
  webUrl: string;
  /** 后端 API 根地址，例如 http://localhost:10101 */
  serverUrl: string;
  /** API 前缀，目前固定 /api/v1 */
  apiPrefix: string;
  assetsDir: string;
  logo: string;
  amapKey: string; // jsapi key
  amapWebServerKey: string; // web server key
  ossDir: string;
  defaultArea: {
    province: { label: string; value: string } | null;
    city: { label: string; value: string } | null;
    district: { label: string; value: string } | null;
    latitude?: number;
    longitude?: number;
  };
  auth: {
    /** 认证方式，目前仅支持 JWT */
    method: 'jwt';
    /** 是否跳过认证（仅本地调试用） */
    skip: boolean;
    /** 登录后默认重定向路径 */
    redirectPath: string;
  };
  isDev: boolean;
};

// ----------------------------------------------------------------------

/** 规范化二级目录前缀：去掉尾部斜杠，根路径部署时返回空字符串 */
const normalizeBaseUrl = (path: string): string => {
  if (!path || path === '/') {
    return '';
  }
  return path.replace(/\/$/, '');
};

const baseUrl = normalizeBaseUrl(import.meta.env.VITE_BASE_URL || import.meta.env.BASE_URL || '');

export const CONFIG: ConfigValue = {
  areaJsonUrl: import.meta.env.VITE_AREA_JSON_URL ?? '',
  appName: import.meta.env.VITE_APP_NAME ?? '',
  appVersion: packageJson.version,
  baseUrl: baseUrl ?? '',
  webUrl: import.meta.env.VITE_WEB_URL ?? '',
  serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
  apiPrefix: import.meta.env.VITE_API_PREFIX ?? '/api/v1',
  assetsDir: import.meta.env.VITE_ASSETS_DIR ?? '',
  amapKey: import.meta.env.VITE_AMAP_KEY ?? '',
  amapWebServerKey: import.meta.env.VITE_AMAP_WEB_SERVER_KEY ?? '',
  defaultArea: DEFAULT_LOCATION,
  isDev: import.meta.env.VITE_IS_DEV === 'true' || import.meta.env.DEV,
  ossDir: import.meta.env.VITE_OSS_DIR ?? '',
  logo: `${import.meta.env.VITE_ASSETS_DIR ?? ''}/logo/logo-single.png`,
  auth: {
    method: 'jwt',
    skip: false,
    redirectPath: baseUrl + paths.dashboard.root,
  },
};
